import axios from 'axios'

export default {
    namespaced: true,
    state: {
        housingApplicationAttachments: [],
        housingApplicationAttachment: {},
    },
    mutations: {
        SET_HOUSING_APPLICATION_ATTACHMENTS(state, payload) {
            state.housingApplicationAttachments = payload;
        },
        SET_HOUSING_APPLICATION_ATTACHMENT(state, payload) {
            state.housingApplicationAttachment = payload;
        },
    },
    actions: {
        async FetchHousingApplicationAttachments({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/attachments/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_HOUSING_APPLICATION_ATTACHMENTS', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchHousingApplicationAttachments: ${error.message}`));
            });
        },
        async FetchHousingApplicationAttachment({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/attachments/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_HOUSING_APPLICATION_ATTACHMENT', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchHousingApplicationAttachment: ${error.message}`));
            });
        },
        async InsertHousingApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/attachments/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertHousingApplicationAttachment: ${error.message}`));
            });
        },
        async DeleteHousingApplicationAttachment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/attachments/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteHousingApplicationAttachment: ${error.message}`));
            });
        },
    },
    getters: {
        HousingApplicationAttachments(state) { return state.housingApplicationAttachments; },
        HousingApplicationAttachment(state) { return state.housingApplicationAttachment; },
    }
}
